import { createAction, props } from '@ngrx/store';

export const loadAnalysisResultsTexts = createAction(
  '[AnalysisResultsTextStore] Load AnalysisResultsTextStores'
);

export const loadAnalysisResultsTextsSuccess = createAction(
  '[AnalysisResultsTextStore] Load AnalysisResultsTextStores Success',
  props<{ data: any }>()
);

export const loadAnalysisResultsTextsFailure = createAction(
  '[AnalysisResultsTextStore] Load AnalysisResultsTextStores Failure',
  props<{ error: any }>()
);
